import moment from 'moment'
import axios from 'axios'


export default {
  data () {
    return {
      leobermon: 'holiman',
      camioneta: 'N/A',
      sSD: '',
      vAlta: '',
      vBaja: '',
      vResult: '',
      sAguinaldo: 13.13,
      sPrima: 0,
      sVacaciones: 1.7000,
      aInicio: '',
      aBaja: '',
      aResult: ''
    }
  },

  methods: {
    // tableToExcel:function(table,name) {
    tableToExcel:function() {
      console.log("en tableToExcel");
      var a = 'hola sham';
      console.log(a);
        var uri = 'data:application/vnd.ms-excel;base64,';
             var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
             console.log(template,'<--template');
        
          console.log("En la función");
          var table = 'testTable'; var name= 'W3C Example Table';
            if (!table.nodeType) table = document.getElementById(table)
            var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            window.location.href = uri + (window.btoa(unescape(encodeURIComponent(template.replace(/{(\w+)}/g, function(m, p) { return ctx[p]; })))))
      },

    Unidades:function(num){


      switch(num)
      {
          case 1: return "UN";
          case 2: return "DOS";
          case 3: return "TRES";
          case 4: return "CUATRO";
          case 5: return "CINCO";
          case 6: return "SEIS";
          case 7: return "SIETE";
          case 8: return "OCHO";
          case 9: return "NUEVE";
      }

      return "";
  },//Unidades()

  Decenas:function(num){
    var estancia = this;

      var decena = Math.floor(num/10);
      var unidad = num - (decena * 10);

      switch(decena)
      {
          case 1:
              switch(unidad)
              {
                  case 0: return "DIEZ";
                  case 1: return "ONCE";
                  case 2: return "DOCE";
                  case 3: return "TRECE";
                  case 4: return "CATORCE";
                  case 5: return "QUINCE";
                  default: return "DIECI" + estancia.Unidades(unidad);
              }
          case 2:
              switch(unidad)
              {
                  case 0: return "VEINTE";
                  default: return "VEINTI" + estancia.Unidades(unidad);
              }
          case 3: return estancia.DecenasY("TREINTA", unidad);
          case 4: return estancia.DecenasY("CUARENTA", unidad);
          case 5: return estancia.DecenasY("CINCUENTA", unidad);
          case 6: return estancia.DecenasY("SESENTA", unidad);
          case 7: return estancia.DecenasY("SETENTA", unidad);
          case 8: return estancia.DecenasY("OCHENTA", unidad);
          case 9: return estancia.DecenasY("NOVENTA", unidad);
          case 0: return estancia.Unidades(unidad);
      }
  },//Unidades()

  DecenasY:function(strSin, numUnidades) {
    var estancia = this;
      if (numUnidades > 0)
      return strSin + " Y " + estancia.Unidades(numUnidades)

      return strSin;
  },//DecenasY()

  Centenas:function(num) {
    var estancia = this;

      var centenas = Math.floor(num / 100);
      var decenas = num - (centenas * 100);

      switch(centenas)
      {
          case 1:
              if (decenas > 0)
                  return "CIENTO " + estancia.Decenas(decenas);
              return "CIEN";
          case 2: return "DOSCIENTOS " + estancia.Decenas(decenas);
          case 3: return "TRESCIENTOS " + estancia.Decenas(decenas);
          case 4: return "CUATROCIENTOS " + estancia.Decenas(decenas);
          case 5: return "QUINIENTOS " + estancia.Decenas(decenas);
          case 6: return "SEISCIENTOS " + estancia.Decenas(decenas);
          case 7: return "SETECIENTOS " + estancia.Decenas(decenas);
          case 8: return "OCHOCIENTOS " + estancia.Decenas(decenas);
          case 9: return "NOVECIENTOS " + estancia.Decenas(decenas);
      }

      return estancia.Decenas(decenas);
  },//Centenas()

  Seccion:function(num, divisor, strSingular, strPlural) {
    var estancia = this;

      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var letras = "";

      if (cientos > 0)
          if (cientos > 1)
              letras = estancia.Centenas(cientos) + " " + strPlural;
          else
              letras = strSingular;

      if (resto > 0)
          letras += "";

      return letras;
  },//Seccion()

  Miles:function(num) {
    var estancia = this;

      var divisor = 1000;
      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var strMiles = estancia.Seccion(num, divisor, "UN MIL", "MIL");
      var strCentenas = estancia.Centenas(resto);

      if(strMiles == "")
          return strCentenas;

      return strMiles + " " + strCentenas;
  },//Miles()

  Millones:function(num) {
    var estancia = this;

      var divisor = 1000000;
      var cientos = Math.floor(num / divisor)
      var resto = num - (cientos * divisor)

      var strMillones = estancia.Seccion(num, divisor, "UN MILLON DE", "MILLONES DE");
      var strMiles = estancia.Miles(resto);

      if(strMillones == "")
          return strMiles;

      return strMillones + " " + strMiles;
  },//Millones()

  NumeroALetras:function(num) {
    var estancia = this;

      var data = {
          numero: num,
          enteros: Math.floor(num),
          centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
          letrasCentavos: " ",
          letrasMonedaPlural: 'PESOS M.N.',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
          letrasMonedaSingular: 'PESO M.N.', //"PESO", 'Dólar', 'Bolivar', 'etc'

          letrasMonedaCentavoPlural: "CENTAVOS",
          letrasMonedaCentavoSingular: "CENTAVO"
      };

      if (data.centavos > 0) {
          data.letrasCentavos = "CON " + (function (){
              if (data.centavos == 1)
                  return estancia.Millones(data.centavos) + " " + data.letrasMonedaCentavoSingular;
              else
                  return estancia.Millones(data.centavos) + " " + data.letrasMonedaCentavoPlural;
              })();
      };

      if(data.enteros == 0)
          return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
          return estancia.Millones(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
      else
          return estancia.Millones(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
  },//NumeroALetras()


    insertRegistro: function (user,tCambio, sujeto_id, after, before) {

      axios.post('http://localhost:3000/justInsert',{
        table: "registro_movimientos",
        columns: " usuario, time, tCambio, sujeto_id, afterChange, beforeChange",
        values: ` '${user}', '${moment().format('YYYY-MM-DD HH:mm:ss')}', '${tCambio}', '${sujeto_id}', '${after}', '${before}'`
      })
      .then(function(response){

        if (response.status == 200 ) {
          console.log('regreso del insert ');
          console.log(response.data);
        }else{
          console.log('error');
        }

      });
    //----------

    },

    insertDocumentBackup:function(id_colaborador, tipo_doc, fecha_ini, fecha_fin, fecha_doc, version_doc, empresa, ultima_empresa, ultima_empresa_date, area, puesto, salario, insert_date, inserted_by, obs){
          var estancia=this;

          axios.post('http://localhost:3000/justInsert', { //insertamos el backup del documento
            table: 'documentos_backup',
            columns: ' id_colaborador, tipo_doc, fecha_ini, fecha_fin, fecha_doc, version_doc, empresa, ultima_empresa, ultima_empresa_date, area, puesto, salario, insert_date, inserted_by, obs',
            values: ` '${id_colaborador}', '${tipo_doc}', '${fecha_ini}', '${fecha_fin}', '${fecha_doc}', '${version_doc}', '${empresa}', '${ultima_empresa}', '${ultima_empresa_date}', '${area}','${puesto}' , '${salario}','${insert_date}','${inserted_by}','${obs}'   `
          })
            .then(function (response) {

              if (response.status == 200) {
                  console.log("registrado en documentos_backup");
                  estancia.$snotify.success('Se guarda una copia del archivo generado ', 'Se guarda copia del documento', { // notificacion
                    timeout: 2000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true
                  });

              } else {
                console.log('error')
              }

            })

    },
    generarFiniquito:function(datosUser,opcMeses, temporal){

      if(temporal == 1){
        var apellidoMat = (datosUser.apellido_materno != '*' ) ? datosUser.apellido_materno : ' ';
        var completeName = datosUser.nombre + ' ' + datosUser.apellido_paterno + ' ' + apellidoMat ;

        console.log('----------------');
        console.log('los meses que agregamos al contrato' + opcMeses);

        var fechaInicioContratoActual = moment(datosUser.ini_contrato, 'YYYY-MM-DD')
        var fechaFinalContratoActualA = moment(datosUser.fin_contrato, 'YYYY-MM-DD')
        var fechaFinalContratoActualB = moment(datosUser.fin_contrato, 'YYYY-MM-DD')

        console.log('fecha inicio contrato actual' + fechaInicioContratoActual.format('YYYY-MM-DD'))
        console.log('fecha final contratoactual' + fechaFinalContratoActualA.format('YYYY-MM-DD'))

        var fechaInicioContratoSiguiente = fechaFinalContratoActualA.add(1, 'months').startOf('month')
        var fechaFinalContratoSiguiente = fechaFinalContratoActualB.add(opcMeses, 'month').endOf('month')

        console.log('----------------');
        console.log('fecha inico contrato siguiente' + fechaInicioContratoSiguiente.format('YYYY-MM-DD'))
        console.log('fecha final contrato siguiente' + fechaFinalContratoSiguiente.format('YYYY-MM-DD'))

        var startOfWeek = moment().add(3, 'month').startOf('month');
        var endOfWeek = moment().add(1, 'month').endOf('month');

        var nuevaFechafin = '';
        var nuevaFechaini = '';
        ///---------


              if(fechaInicioContratoSiguiente.format('MM-DD') == "01-01" ) {
                console.log('NO SE PUEDE - la fecha es de inicio de ano');
                //console.log( "dia de final " + fechaInicioContratoSiguiente.subtract(1,'m').subtract(1,'d').format('YYYY-MM-DD') );
                nuevaFechaini = fechaInicioContratoSiguiente.subtract(1,'d');
              }else{
                console.log(' si se puede la fecha fina;');
                nuevaFechaini = fechaInicioContratoSiguiente;
              }

              if(fechaFinalContratoSiguiente.format('MM-DD') == "12-31" ){
                console.log('NO SE PUEDE - estamos a final del ano')
                var temporalMenos = fechaFinalContratoSiguiente.subtract(1, 'd')
                console.log('dia de final' + temporalMenos)
                nuevaFechafin = temporalMenos
              }else{
                console.log('si se puede la fecha final');
                nuevaFechafin = fechaFinalContratoSiguiente;
              }

        ////---------

        console.log('la nueva fecha ini del contrato es ' + nuevaFechaini.format('YYYY-MM-DD'));
        console.log('la nueva fecha fin del contrato es ' + nuevaFechafin.format('YYYY-MM-DD') );

        var nuevaFechainiagui = nuevaFechaini;
        var nuevaFechafinagui = nuevaFechafin;

      }else{

        var nuevaFechaini = moment(datosUser.ultima_empresa_date, 'YYYY-MM-DD');
        var nuevaFechafin = moment();

        var nuevaFechainiagui = moment(datosUser.ultima_empresa_date, 'YYYY-MM-DD');
        var nuevaFechafinagui = moment();

      }





      var a = moment([2007, 0, 29]);
      var b = moment([2007, 0, 28]);
      a.diff(b, 'days')   // =1





      var fechadelcontrato =  nuevaFechaini.format('DD') + " de " + nuevaFechaini.format('MMMM') + " del  " + nuevaFechaini.format('YYYY') ;
      var fechadelcontratofin =  nuevaFechafin.format('DD') + " de " + nuevaFechafin.format('MMMM') + " del  " + nuevaFechafin.format('YYYY') ;

      var apellidoMat = (datosUser.apellido_materno != '*' ) ? datosUser.apellido_materno : '' ;
      var nombredeloperador = datosUser.nombre + " " + datosUser.apellido_paterno + " " + apellidoMat ;
      var salarioDiario = datosUser.sueldo;

      var vFechaIncio = "2-8-2018";
      var vFechaFinal = "12-11-2018";
      var difdV = (nuevaFechaini.diff(nuevaFechafin, 'days') < 0 ) ? (nuevaFechaini.diff(nuevaFechafin, 'days') * -1) : nuevaFechaini.diff(nuevaFechafin, 'days') ;

      var aFechainicio = "1-1-2018";
      var aFechafinal = "12-11-2018";
      var difDA = (nuevaFechainiagui.diff(nuevaFechafinagui, 'days') < 0 ) ? (nuevaFechainiagui.diff(nuevaFechafinagui, 'days') * -1) : nuevaFechainiagui.diff(nuevaFechafinagui, 'days') ;

      var setAguinaldo = 15;
      var setvacaciones = 6;
      var setprimavacacional = .25 ;

      var aguinaldo = (difDA / 360)*setAguinaldo;
      console.log('aguinaldo: ' + difDA + '/' + 360 + ' *' + setAguinaldo + ' =  ' + aguinaldo);
      var primaD = 0;
      var vacaciones = (difdV/360)*setvacaciones;
      console.log('vacaciones' + difdV + ' / ' + 360 + ' * ' + setvacaciones + ' = ' + vacaciones );

      var totalAguinaldo = aguinaldo * salarioDiario;
      console.log('total aguinaldo ' + aguinaldo +  ' * ' + salarioDiario + ' = ' + totalAguinaldo);
      var totalPrimaDomi = (.25)*(salarioDiario)*(primaD);
      console.log('total prima  ' + .25 + '*' + salarioDiario + '* ' + primaD);
      var totalVacaciones =  vacaciones * salarioDiario;
      console.log('totalvacaciones ' + vacaciones + ' * ' + salarioDiario + ' = ' + totalVacaciones);
      var totalPrimaVaca = totalVacaciones * setprimavacacional;
      console.log('total prima vaca ' + totalVacaciones + '*' + setprimavacacional + ' = ' + totalPrimaVaca);

      var totalFinal = totalAguinaldo + totalPrimaDomi + totalPrimaVaca + totalVacaciones;
      console.log('totalfinal = ' + totalAguinaldo + ' + '+ totalPrimaDomi + ' +' + totalPrimaVaca + ' + ' + totalVacaciones + ' = ' + totalFinal );
      console.log('total - ' + totalFinal);
      var totalFinal2 = totalFinal.toFixed(2)

      var docDefinition = {
        content: [
          {text: datosUser.nameE , style: 'header',alignment: 'center', decoration: 'underline',decorationStyle: 'solid', decorationColor: 'black'},
          `\n NOMBRE DEL TRABAJADOR : ${nombredeloperador} \n\n FECHA DE INGRESO: ${ fechadelcontrato } \n\n SALARIO DIARIO: $ ${ datosUser.sueldo } \n\n PUESTO: ${ datosUser.puesto  }  \n\n ÚLTIMO DIA DE LABORES: ${ fechadelcontratofin }  `,

          {
            text:'_______________________________________________________________________________________________'
          },
          {text: 'RECIBO DE FINIQUITO POR RENUNCIA VOLUNTARIA', style: 'subheader',fontSize: 10, alignment:'center'},
            {
            style: 'tableExample',
            table: {
              widths: ['*', 120, 120],
              body: [
                ['CONCEPTO','PERCEPCIONES', 'DEDUCCIONES'],
                [{text: 'PROPORCION DE VACACIONES', italics: true}, {text: ' $ ' + totalVacaciones.toFixed(2) , italics: true, alignment:'center'}, {text: ' ', italics: true}],
                [{text: 'PROPORCION DE PRIMA VACACIONAL', italics: true}, {text: ' $ ' +totalPrimaVaca.toFixed(2) , italics: true, alignment:'center'}, {text: ' ', italics: true}],
                [{text: 'PROPORCION DE PRIMA DOMINICAL', italics: true}, {text: ' $ ' +totalPrimaDomi.toFixed(2) , italics: true, alignment:'center'}, {text: ' ', italics: true}],
                [{text: 'PROPORCION DE AGUINALDO', italics: true}, {text: ' $ ' + totalAguinaldo.toFixed(2) , italics: true, alignment:'center'}, {text: ' ', italics: true}],
                [{text: 'TOTALES',alignment:'right', bold:true ,italics: true}, {text: ' $ ' +totalFinal2, italics: true, alignment:'center'}, {text: ' ', italics: true}],
                [{text: ' ',alignment:'right', bold:true ,italics: true}, {text: ' NETO A PAGAR ',bold:true, italics: true, alignment:'center'}, {text:'$' + totalFinal2, italics: true}]
              ]
            }
          },
          {
            text:'_______________________________________________________________________________________________'
          },
          {
            text:['RECIBÍ DE LA EMPRESA ' ,{text:datosUser.nameE,bold:true}, {text: ', LA CANTIDAD TOTAL INDICADA, POR LOS CONCEPTOS QUE AHÍ SE DETALLAN, EN VIRTUD DE LA RENUNCIA VOLUNTARIA QUE LES PRESENTÉ EN LA FECHA QUE SE MENCIONA EN ESTE RECIBO, FIRMANDO EL PRESENTE DE ENTERA CONFORMIDAD',margin: [0, 20, 0, 0] } ],
            alignment: 'justify'
          },
          {
            text: "CANCUN, QUINTANA ROO, A " + fechadelcontratofin ,margin: [0, 80, 0, 0],alignment:'right'
          },
          {
            text:'_______________________________________________',margin: [0, 100, 0, 0],alignment:'center'
          },
          {
            text: nombredeloperador ,margin: [0, 0, 0, 0],alignment:'center'
          }
        ],
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 12,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 12,
            color: 'black'
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }

      }
      pdfMake.createPdf(docDefinition).open();
    },
    generateContrato:function(datosUser, opcMeses){

      var apellidoMat = (datosUser.apellido_materno != '*' ) ? datosUser.apellido_materno : ' ';
      var completeName = datosUser.nombre + ' ' + datosUser.apellido_paterno + ' ' + apellidoMat ;

      console.log('----------------');
      console.log('los meses que agregamos al contrato' + opcMeses);

      var fechaInicioContratoActual = moment(datosUser.ini_contrato, 'YYYY-MM-DD')
      var fechaFinalContratoActualA = moment(datosUser.fin_contrato, 'YYYY-MM-DD')
      var fechaFinalContratoActualB = moment(datosUser.fin_contrato, 'YYYY-MM-DD')

      console.log('fecha inicio contrato actual' + fechaInicioContratoActual.format('YYYY-MM-DD'))
      console.log('fecha final contratoactual' + fechaFinalContratoActualA.format('YYYY-MM-DD'))

      var fechaInicioContratoSiguiente = fechaFinalContratoActualA.add(1, 'months').startOf('month')
      var fechaFinalContratoSiguiente = fechaFinalContratoActualB.add(opcMeses, 'month').endOf('month')

      console.log('----------------');
      console.log('fecha inico contrato siguiente' + fechaInicioContratoSiguiente.format('YYYY-MM-DD'))
      console.log('fecha final contrato siguiente' + fechaFinalContratoSiguiente.format('YYYY-MM-DD'))

      var startOfWeek = moment().add(3, 'month').startOf('month');
      var endOfWeek = moment().add(1, 'month').endOf('month');

      var nuevaFechafin = '';
      var nuevaFechacon = '';
      ///---------


            if(fechaInicioContratoSiguiente.format('MM-DD') == "01-01" ) {
              console.log('NO SE PUEDE - la fecha es de inicio de ano');
              //console.log( "dia de final " + fechaInicioContratoSiguiente.subtract(1,'m').subtract(1,'d').format('YYYY-MM-DD') );
              nuevaFechacon = fechaInicioContratoSiguiente.subtract(1,'d');
            }else{
              console.log(' si se puede la fecha fina;');
              nuevaFechacon = fechaInicioContratoSiguiente;
            }

            if(fechaFinalContratoSiguiente.format('MM-DD') == "12-31" ){
              console.log('NO SE PUEDE - estamos a final del ano')
              var temporalMenos = fechaFinalContratoSiguiente.subtract(1, 'd')
              console.log('dia de final' + temporalMenos)
              nuevaFechafin = temporalMenos
            }else{
              console.log('si se puede la fecha final');
              nuevaFechafin = fechaFinalContratoSiguiente;
            }

      ////---------

      console.log('la nueva fecha ini del contrato es ' + nuevaFechacon.format('YYYY-MM-DD'));
      console.log('la nueva fecha fin del contrato es ' + nuevaFechafin.format('YYYY-MM-DD') );

      var docDefinition = {
        content: [
            {text: [{text:'CONTRATO INDIVIDUAL DE TRABAJO POR TIEMPO DETERMINADO',bold:true},' que celebran por una parte ',{text:completeName ,bold:true},', en adelante ',{text:' "EL TRABAJADOR" ',bold:true},', con la empresa ',{text: datosUser.nameE ,bold:true},', en adelante ',{text:' "EL PATRON" ',bold:true},', con domicilio ',{text: datosUser.direccionE ,bold:true},' misma que se encuentra constituida de acuerdo a las leyes de los Estados Unidos Mexicanos, y que se encuentra representada en este acto por ',{text:datosUser.tituloE + ' ' + datosUser.representanteE  ,bold:true},', ambas partes comparecen de mutuo acuerdo y voluntad propia de conformidad con las siguientes:'], alignment: 'justify'},
          {
            text: 'DECLARACIONES',
            margin: [0, 10],
            fontSize: 10,
            alignment: 'center'
          },
          {
            text: 'I. EL TRABAJADOR manifiesta',
            margin: [0, 2],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: [`a) Ser de nacionalidad ${datosUser.nacionalidad}, con `,{text: moment().diff(datosUser.fecha_nacimiento , 'years'), bold:true },` años de edad, de estado civil ${datosUser.estado_civil}, con Clave Única de Registro de Población ${ datosUser.curp }  y Registro Federal de Contribuyentes ${ datosUser.rfc }.`],
            margin: [20,2],
            fontSize: 10,
             alignment: 'justify'
          },
          {
            text: ['b) Tener su domicilio en ',{text: datosUser.direccion ,bold:true},' de esta ciudad.'],
            margin: [20,2],
            fontSize: 10,
             alignment: 'justify'
          },
          {
            text: 'c) Que actualmente no presta servicios subordinados o independientes para ninguna persona; Así mismo, que está en capacidad y aptitud y tiene los conocimientos y habilidades necesarios para prestar los servicios a que se refiere este contrato.',
            margin: [20,2],
            fontSize: 10,
             alignment: 'justify'
          },
          {
            text: 'd) Que no tiene enfermedad o incapacidad que le imposibilite para desempeñar el trabajo para el que es contratado(a), ya sea permanente, parcial o transitorio.',
            margin: [20,2],
            fontSize: 10,
             alignment: 'justify'
          },
          {
            text: 'e) Que cumple con la documentación legal necesaria para realizar las actividades inherentes al trabajo, contenidas en el presente contrato.',
            margin: [20,2],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'II. EL PATRON manifiesta',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text:[ 'a) Ser una sociedad debidamente constituida y existente de conformidad con las leyes mexicanas, con domicilio en ',{text: datosUser.direccionE, bold:true} ],
            margin: [20,2],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'b) que se dedica principalmente a la prestación de servicios de transporte turístico por tierra.',
            margin: [20,2],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text:[ 'c) La necesidad extrema y espontánea de contratar a una persona durante tiempo determinado, para cubrir el puesto y desempeñar las funciones de ', {text:datosUser.puesto ,bold:true} ,' .'],
            margin: [20,2],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'De igual forma, ambas partes y de común acuerdo, celebran el presente contrato, sujetándose al tenor de las siguientes:',
            margin: [0,20],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'CLAUSULAS',
            margin: [0, 10],
            fontSize: 10,
            bold:true,
            alignment: 'center'
          },
            {
            text: 'I. Objeto de Contrato y modalidad',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: `a) El presente contrato es por tiempo determinado, el cual comienza en la fecha de su firma y termina en fecha ${  nuevaFechafin.format('DD') + ' de ' + nuevaFechafin.format('MMMM') + " del " + nuevaFechafin.format('YYYY') } .`,
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text:[ 'b) El TRABAJADOR prestará personalmente al PATRÓN los servicios pactados en este contrato, en el área de ' + datosUser.deparName +  ' desempeñando el puesto de ' , {text: datosUser.puesto ,bold:true} ],
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'c) El TRABAJADOR tendrá las obligaciones y responsabilidades que se señalan, en forma enunciativa y no limitativa en la cláusula III del presente contrato y en sus anexos, así como en las labores relacionadas o conexas con su ocupación principal que el PATRÓN ordene durante la relación de trabajo.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'd) En el supuesto de que el TRABAJADOR tenga personal a su servicio, estará obligado a vigilar que el mismo cumpla con todas las instrucciones, políticas, códigos de conducta; reglamentos o manuales que le sean aplicables.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'e) Por razón de los servicios que prestará el TRABAJADOR al PATRÓN, el primero mantendrá relaciones con las empresas o personas físicas y morales que tienen relación con el PATRÓN y otras empresas o clientes del mismo; estos servicios serán siempre por orden y cuenta de este último quien será su único empleador y responsable de su relación de trabajo. ',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'f) El TRABAJADOR y el PATRÓN en el acto de firmar el presente contrato, manifiestan que están de acuerdo en que el PATRÓN podrá, en cualquier momento, pedir al TRABAJADOR que lleve a cabo trabajos o proyectos específicos por el tiempo que sea necesario, para los clientes a los que preste servicios, o con los que se tengan relaciones, pero será siempre por cuenta y orden del PATRÓN quien será el único responsable de la relación laboral.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'g) El TRABAJADOR conviene además en sujetarse a las disposiciones de los reglamentos, manuales y circulares que el PATRÓN expida en relación con las actividades y obligaciones del personal; igualmente a los reglamentos, circulares u ordenamientos que las autoridades competentes expidan en relación a las actividades a que se dedica el PATRÓN.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'h) EL PATRÓN celebra el presente contrato con base en la declaración del TRABAJADOR, quien manifiesta tener la experiencia, la habilidad y los conocimientos necesarios para desempeñar adecuadamente las actividades inherentes al cargo para el que se le contrata. Por lo que, si el PATRÓN determina dentro de un plazo de 30 (treinta) días contados a partir de la fecha de firma de este contrato, que el TRABAJADOR carece de la experiencia o conocimientos que afirma tener, se dará por terminada la relación de trabajo de inmediato, sin responsabilidad para las partes. Lo anterior con fundamento en el artículo 47 fracción I de la Ley Federal del Trabajo.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'II. Salario',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: ['EL TRABAJADOR tendrá un ',{text:'salario de $'+datosUser.sueldo+' pesos ', bold:true}, 'el cual será cubierto de manera quincenal, los días 15 y último de cada mes.' ],
            margin: [0, 5],
            fontSize: 10,
            alignment: 'left'
          },
          {
            text: 'a) El salario indicado comprende el pago correspondiente a días de descanso semanal y de descanso obligatorio que determina la Ley Federal del Trabajo o los que el PATRÓN otorgue eventualmente.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'b) El salario se pagará por quincenas vencidas, ya sea en las instalaciones del PATRÓN, en donde el TRABAJADOR preste sus servicios, o bien, si este así lo solicita, depósitos bancarios y transferencia electrónica a la cuenta que el TRABAJADOR designe para tal efecto.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'c) El TRABAJADOR se obliga a otorgar recibo firmado a favor del PATRÓN por la totalidad de los salarios, percepciones devengadas y jornada laborada a que tenga derecho hasta la fecha del mismo; esto implica un finiquito total hasta la fecha del recibo correspondiente y una constancia periódica de la jornada de trabajo.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'd) La firma del recibo implicará la conformidad de que el salario recibido cubre el trabajo desempeñado; cualquier cantidad a la que el TRABAJADOR crea tener derecho, deberá exigirla precisamente al firmar el recibo.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'e) El PATRÓN hará los pagos y deducciones legales que correspondan por concepto de Seguridad Social, Previsión Social y Vivienda del TRABAJADOR.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'f) Ambas partes están de acuerdo en que el pago del salario se realizará en moneda de curso legal en los Estados Unidos Mexicanos.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'g) Debido a la naturaleza del trabajo que desempeña el TRABAJADOR, este no genera ningún tipo de propina.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'III. Puesto',
            pageBreak: 'before',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: ['a) El TRABAJADOR desempeñará el puesto de ' ,{text:datosUser.puesto, bold:true}, ` el cual consiste en las labores descritas a continuación: ${datosUser.descripcionP} .` ],
            margin: [20, 5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'b) El TRABAJADOR seguirá las instrucciones dadas a través de las personas designadas por el PATRÓN y bajo la subordinación del mismo; igualmente, ejecutará las órdenes que se le impartan durante la relación de trabajo, mismas que llevará a cabo con la mayor intensidad, cuidado y esmero.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'IV. Jornada de Labores',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: 'a) El horario de labores del TRABAJADOR será el comprendido de lunes a sábado de las 09:00 a las 13:00 horas y de las 15:00 a las 19:00 horas interrumpiendo dicha jornada de las 13:00 a las 15:00 horas para descansar e ingerir alimentos fuera de las instalaciones de la empresa descansando los días domingo de cada semana. La jornada podrá ser distribuida de acuerdo a las costumbres de la actividad del PATRÓN a la que se le presten servicios o las necesidades del trabajo, en 4 ó 5 días laborables a la semana en los términos del artículo 59 de la Ley Federal del trabajo, para lo cual el TRABAJADOR otorga en este momento su consentimiento expreso para tal efecto.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'b) El PATRÓN podrá modificar en cualquier momento el horario establecido, de acuerdo a las necesidades del trabajo, condición con la que el TRABAJADOR está de acuerdo.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'c) El PATRÓN no cuenta con tarjetas de asistencia o reloj checador, por lo tanto, el único control de asistencia válido serán los propios recibos de salario, haciendo constar periódicamente en los mismos el pago de un finiquito total por el tiempo laborado durante el período de que se trate; la jornada de trabajo se pacta en este contrato y solo podrá ampliarse o modificarse por escrito y de común acuerdo entre las partes.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'd) El TRABAJADOR tiene prohibido laborar tiempo extraordinario, así como en días de descanso semanal y obligatorio, si no es, mediante orden por escrito del PATRÓN; de lo contrario, no estará autorizado para prestar sus servicios en jornadas extraordinarias.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'V. Dias de Descanso semanal',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: 'Por cada seis días de trabajo corresponderá un día de descanso semanal, el cual será preferentemente el día Domingo de cada semana, o en su defecto el que sea señalado por el PATRÓN, de acuerdo a las necesidades del servicio y el trabajo, el cual podrá variar, situación con la cual el TRABAJADOR está de acuerdo y otorga su consentimiento.',
            margin: [0, 5],
            fontSize: 10,
            bold:false,
            alignment: 'left'
          },
          {
            text: 'VI. Dias de descanso obligatorio',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text: 'a) Los que señala el Artículo 74 de la Ley Federal del Trabajo y los que señale el PATRÓN.',
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'VII. Prestaciones y Beneficios',
            margin: [0, 5],
            fontSize: 10,
            bold:true,
            alignment: 'left',
            decoration: 'underline',
            decorationStyle: 'solid',
            decorationColor: 'black'
          },
          {
            text:[{text:'a) Vacaciones \n', bold:true}, '  El TRABAJADOR disfrutará de un período anual de vacaciones en los términos de lo dispuesto en el artículo 76 de la Ley Federal del Trabajo, o de acuerdo al programa que el PATRÓN formule. \n En el supuesto de que el TRABAJADOR no haya laborado el año completo de servicios, tendrá derecho a que se le otorgue la proporción de vacaciones que corresponda por el tiempo trabajado en el año.'],
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text:[ {text: 'b) Prima de Vacaciones \n' , bold:true}, ' 25% (veinticinco por ciento) del salario que le corresponda durante el período de vacaciones.' ],
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text:[{text:'c) Aguinaldo. \n',bold:true} ,' 15 (quince) días al año de salario base o la proporción del tiempo trabajado en el año.' ],
            margin: [20,5],
            fontSize: 10,
            alignment: 'justify'
          },
          {
                text: 'VIII. Lugar de trabajo',
                margin: [0, 5],
                fontSize: 10,
                bold:true,
                alignment: 'left',
                decoration: 'underline',
                decorationStyle: 'solid',
                decorationColor: 'black'
              },
              {
                text: 'a) El TRABAJADOR prestará sus servicios en las instalaciones del PATRÓN; en el lugar o lugares que este le señale; en cualquiera de los departamentos, sucursales u oficinas a que sea asignado en la República Mexicana o en el extranjero en donde se requieran sus servicios, o bien, en el o los lugares en donde el PATRÓN realice actividades o tenga operaciones; en sus domicilios, o en los domicilios de las empresas a las que se les presten servicios; solo por orden y cuenta del PATRÓN.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'b) EL TRABAJADOR, en el acto de firmar el presente contrato, se da por enterado que el PATRÓN tiene operaciones en varias partes de la República Mexicana; por lo tanto, debe aceptar como condición de su contratación la movilidad de su lugar o área de trabajo de acuerdo a las necesidades de la operación; por ello el TRABAJADOR acepta, estar de acuerdo y da su consentimiento expreso para que el PATRÓN, en cualquier momento, modifique el lugar donde prestará sus servicios dentro de la República Mexicana o en el extranjero de manera temporal o definitiva, e incluso se modifique el lugar en donde deba radicar para el adecuado desempeño de sus funciones. Queda enterado del alcance y contenido de este pacto, como condición para su contratación.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'IX. Obligaciones varias',
                margin: [0, 5],
                fontSize: 10,
                bold:true,
                alignment: 'left',
                decoration: 'underline',
                decorationStyle: 'solid',
                decorationColor: 'black'
              },
              {
                text: 'a) El TRABAJADOR reconoce que son propiedad exclusiva del PATRÓN todos los documentos, programas, listas de clientes, bases de datos de proveedores, artículos, estudios, información, folletos, publicaciones, manuales, dibujos, trazos, software, hardware, fotografías o cualquier otro trabajo intelectual o información que se le proporcione con motivo de la relación de trabajo. Igualmente, los que el TRABAJADOR prepare o formule en relación o conexión con sus servicios; por lo que se obliga a conservarlos en buen estado y entregarlos al PATRÓN en el momento en que este lo requiera, o bien, al terminarse el presente contrato por el motivo que fuere.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'b) EL TRABAJADOR reconoce que son propiedad del PATRÓN los vehículos, instrumentos, herramientas, aparatos, maquinaria y en general, todos los instrumentos de trabajo que se le proporcionen con motivo de la relación de trabajo.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: `c) El TRABAJADOR se obliga a guardar estricta reserva de la información de cualquier naturaleza, documentos en general, políticas, organización, sistemas de administración, comerciales y tecnología usada y/o desarrollada durante el período de su colaboración, procedimientos y todos aquellos hechos y actos que con motivo de su trabajo sean de su conocimiento;  por lo tanto se obliga a no utilizar en su beneficio o en beneficio de terceras personas, ya sea directa o indirectamente, cualquiera de ellos, así como la información, actos y demás hechos que sean de su conocimiento y a no divulgar ninguno de los aspectos de los negocios del  PATRÓN, o de las empresas con él relacionadas o de sus clientes y a no proporcionar a terceras personas, verbalmente o por escrito, directa o indirectamente, información o documento alguno sobre los sistemas o actividades de cualquier clase que observe en el desempeño de sus labores con el PATRÓN o en la relación de éste con las empresas con quienes tenga relaciones o con sus clientes, en cualquier tipo de actividad; los cuales, para los efectos de este contrato se consideran como secreto de marca y de gran valor, entendiéndose toda aquella que haya sido distribuida, recopilada o discutida en juntas y/o reuniones, por lo que el TRABAJADOR no podrá a su vez redistribuirla, comentarla o manejarla o permitir que lo hagan terceras personas que no se encuentren autorizadas para el efecto; siendo también responsabilidad de los grupos de trabajo el manejo de la información que se desprenda por ellos mismos,  o por el personal contratado por estos.`,
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text:[ 'd) El TRABAJADOR ' ,{text: 'deberá guardar absoluta confidencialidad' ,  decoration: 'underline',  decorationStyle: 'solid',decorationColor: 'black'}, ' sobre los asuntos que le sean encomendados o cualquier información que en razón de sus funciones llegase a tener en su poder y deberá usarla exclusivamente en beneficio del PATRÓN; debiendo guardar expresa reserva sobre esta información privilegiada, en la inteligencia de que  el incumplimiento específico de esta obligación, lo hará acreedor a la rescisión de este contrato y por ende de su relación laboral para con el PATRÓN sin responsabilidad para éste último. Lo anterior de conformidad con el artículo 47 de la Ley Federal de Trabajo, independientemente de las penas que impone el Código Penal para el Distrito Federal, en sus artículos 210 y 211 sus correlativos en los diversos códigos penales de los Estados de la República Mexicana.' ],
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'e) Si el TRABAJADOR dejare de cumplir las obligaciones a que se refieren los anteriores apartados, independientemente de su responsabilidad laboral y civil por daños y perjuicios que causare al PATRÓN, este se reserva sus derechos para denunciar el o los delitos que se pudieren configurar.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'f) Es obligación del TRABAJADOR someterse a los reconocimientos médicos que el PATRÓN le solicite, ya sea a través del Instituto Mexicano del Seguro Social o a través del médico que éste determine, pudiendo ser tan amplios como la política establecida al respecto lo determine; ya sea en forma rutinaria o para comprobar que no padece alguna incapacidad o enfermedad profesional o general, física o mental, contagiosa o incurable.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'g) El PATRÓN se obliga a capacitar o adiestrar al TRABAJADOR de acuerdo a los planes y programas que existan o se establezcan conforme a lo dispuesto en la legislación vigente. El TRABAJADOR, por su parte, se obliga a cumplir con todos los programas, cursos, sesiones de grupo o actividades que formen parte de los mismos y a presentar los exámenes de evaluación de conocimientos y aptitudes que le sean requeridos, así como obedecer las indicaciones de las personas que impartan la capacitación y adiestramiento. Igualmente, el TRABAJADOR tendrá la obligación de capacitar a sus compañeros de trabajo o a los trabajadores de las empresas a las que se les presten servicios, cuando así lo solicite al PATRÓN.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'h) El TRABAJADOR está conforme y se obliga a cumplir con las disposiciones del Reglamento Interior de Trabajo y de las demás disposiciones que le sean aplicables.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text:['i) Es obligación del TRABAJADOR ',{text: 'cuidar su uniforme y herramientas de trabajo' ,  decoration: 'underline',  decorationStyle: 'solid',decorationColor: 'black'},' , así como mantener en buen estado dichos objetos y demás que se pongan a su disposición para el desempeño de sus labores.' ],
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text:[ 'j) Es obligación del TRABAJADOR ',{text: 'limpiar su área de trabajo o vehículo a su cargo' ,  decoration: 'underline',  decorationStyle: 'solid',decorationColor: 'black'},' , después de haber realizado algún servicio y antes del cierre del negocio. Dicha área de labores deberá quedar limpia para evitar accidentes.' ],
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'k) El TRABAJADOR se obliga a no desempeñar dentro de su jornada laboral, trabajos personales, o para terceras personas; actos de comisión mercantil, consignación, intermediación o de cualquier especie aún cuando no sean remunerados, para sí o para personas distintas del PATRÓN, ya que su jornada de trabajo debe destinarse al cumplimiento de las labores pactadas en este contrato.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'l) Los gastos o viáticos que se ocasionen en el desempeño de las labores deberán ajustarse a las políticas que el PATRÓN determine. En todo caso y previa autorización por escrito del PATRÓN, el TRABAJADOR deberá presentar los comprobantes y relaciones de gastos que se requieran, acompañando los documentos que reúnan los requisitos que las leyes fiscales establecen.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'm) El TRABAJADOR se obliga a tener y conservar en todo momento y durante el desempeño de sus labores, la documentación exigida por las leyes y Reglamentos, para la realización de su trabajo; en caso de que, por razón imputables al trabajador, este no cumpla con los requisitos legales que ordenan las autoridades competentes, la relación laboral se suspenderá en términos de lo establecido en el artículo 42 Fracción VII de la Ley Federal del Trabajo.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'n) Queda aceptado por las partes que serán causas de rescisión sin responsabilidad para el PATRÓN, sin perjuicio de las que al efecto señala la Ley Federal del Trabajo las siguientes:',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'I) La falta de cumplimiento adecuado por parte del TRABAJADOR, de las instrucciones que, en forma verbal o por escrito, se hayan dado; o las que se den por el PATRÓN a través de sus representantes autorizados, que se relacionen directa o indirectamente con las labores contratadas.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'II) La falta de veracidad de la información proporcionada por el TRABAJADOR al PATRÓN previa a la celebración de este contrato.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'III) Que el TRABAJADOR realice actividades ajenas a las del PATRÓN o a los clientes de éste, ya sea por cuenta propia o por cuenta de otra institución, persona física o moral, salvo autorización expresa.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'IV) La existencia, en cualquier momento, de cualquier conflicto de intereses entre el TRABAJADOR y el PATRÓN o los clientes de éste o cualquier otro tercero relacionado comercial, técnica, financiera, operativamente o de cualquier otra índole.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'V) La realización de cualquiera de los actos prohibidos por el Reglamento Interior de Trabajo del PATRÓN, o por las leyes y correlacionados que rigen la buena conducta.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'VI) Dar a conocer a terceros ajenos a la relación laboral cualquier clase de información y demás datos confidenciales que reciba con motivo de su trabajo.',
                margin: [40,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'X. Conducta y comportamiento',
                margin: [0, 5],
                fontSize: 10,
                bold:true,
                alignment: 'justify',
                decoration: 'underline',
                decorationStyle: 'solid',
                decorationColor: 'black'
              },
              {
                text: 'a) Queda estrictamente prohibido que el TRABAJADOR fume o ingiera bebidas alcohólicas dentro del centro de trabajo o vehículo propiedad del PATRÓN; de igual manera, le está prohibido al TRABAJADOR el uso de teléfonos celulares o radios durante la jornada de labores y en tanto se encuentre a bordo de algún vehículo, salvo que sea por situación de emergencia.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'b) Para efectos de la comisión de alguna falta o incumplimiento relativo a la conducta y comportamiento, ambas partes quedarán sujetas a lo establecido en el Reglamento Interior de Trabajo y las sanciones que el mismo establezca.',
                margin: [20,5],
                fontSize: 10,
                alignment: 'justify'
              },
              {
                text: 'Leído que fue por las partes este documento, una vez enteradas de su contenido, obligaciones y alcance; estando de acuerdo que lo no previsto en este contrato se estará a lo dispuesto por la Ley Federal del Trabajo. \n \n Firman de común acuerdo en su fecha. \n\n',
                margin: [0, 5],
                fontSize: 10,
                bold:false,
                alignment: 'justify'
              },
              {
                text:[ {text: `Cancún, Municipio de Benito Juárez, Quintana Roo, a ${ nuevaFechacon.format('DD') + ' de ' + nuevaFechacon.format('MMMM') + " del " + nuevaFechacon.format('YYYY') } ` ,bold:true}  ],
                margin: [0, 20],
                fontSize: 10,
                bold:false,
                alignment: 'right'
              },
              {

            columns: [
              {
                text:[ {text: 'EL TRABAJADOR \n\n\n\n\n\n ____________________________________ \n  '+ completeName ,bold:true} ] ,
                alignment: 'center',
                fontSize: 10
              },
              {
                text:[ { text: 'EL PATRON \n\n\n\n\n\n ____________________________________ \n ' + datosUser.representanteE + "\n\n REPRESENTANTE LEGAL"  ,bold:true } ] ,
                alignment: 'center',
                fontSize: 10
              }
            ]
          },


        ],
        styles: {

          header: {
            bold: true,
            fontSize: 14
          }
        },
        defaultStyle: {
          fontSize: 12
        }

      }
      pdfMake.createPdf(docDefinition).open();

    },
    generarRenuncia:function(datosUser, opcMeses, temporal){

      if(temporal == 1){

        var apellidoMat = (datosUser.apellido_materno != '*' ) ? datosUser.apellido_materno : ' ';
        var completeName = datosUser.nombre + ' ' + datosUser.apellido_paterno + ' ' + apellidoMat ;

        console.log('----------------');
        console.log('los meses que agregamos al contrato' + opcMeses);

        var fechaInicioContratoActual = moment(datosUser.ini_contrato, 'YYYY-MM-DD')
        var fechaFinalContratoActualA = moment(datosUser.fin_contrato, 'YYYY-MM-DD')
        var fechaFinalContratoActualB = moment(datosUser.fin_contrato, 'YYYY-MM-DD')

        console.log('fecha inicio contrato actual' + fechaInicioContratoActual.format('YYYY-MM-DD'))
        console.log('fecha final contratoactual' + fechaFinalContratoActualA.format('YYYY-MM-DD'))

        var fechaInicioContratoSiguiente = fechaFinalContratoActualA.add(1, 'months').startOf('month')
        var fechaFinalContratoSiguiente = fechaFinalContratoActualB.add(opcMeses, 'month').endOf('month')

        console.log('----------------');
        console.log('fecha inico contrato siguiente' + fechaInicioContratoSiguiente.format('YYYY-MM-DD'))
        console.log('fecha final contrato siguiente' + fechaFinalContratoSiguiente.format('YYYY-MM-DD'))

        var startOfWeek = moment().add(3, 'month').startOf('month');
        var endOfWeek = moment().add(1, 'month').endOf('month');

        var nuevaFechafin = '';
        var nuevaFechaini = '';
        ///---------


              if(fechaInicioContratoSiguiente.format('MM-DD') == "01-01" ) {
                console.log('NO SE PUEDE - la fecha es de inicio de ano');
                //console.log( "dia de final " + fechaInicioContratoSiguiente.subtract(1,'m').subtract(1,'d').format('YYYY-MM-DD') );
                nuevaFechaini = fechaInicioContratoSiguiente.subtract(1,'d');
              }else{
                console.log(' si se puede la fecha fina;');
                nuevaFechaini = fechaInicioContratoSiguiente;
              }

              if(fechaFinalContratoSiguiente.format('MM-DD') == "12-31" ){
                console.log('NO SE PUEDE - estamos a final del ano')
                var temporalMenos = fechaFinalContratoSiguiente.subtract(1, 'd')
                console.log('dia de final' + temporalMenos)
                nuevaFechafin = temporalMenos
              }else{
                console.log('si se puede la fecha final');
                nuevaFechafin = fechaFinalContratoSiguiente;
              }

        ////---------

        console.log('la nueva fecha ini del contrato es ' + nuevaFechaini.format('YYYY-MM-DD'));
        console.log('la nueva fecha fin del contrato es ' + nuevaFechafin.format('YYYY-MM-DD') );



      }else{
        var nuevaFechaini = moment(datosUser.ultima_empresa_date, 'YYYY-MM-DD');
        var nuevaFechafin = moment();
      }



      var apellidoMat = (datosUser.apellido_materno != '*' ) ? datosUser.apellido_materno : ' ' ;



      var fonts = {

        Times: {
          normal: 'Times-Roman',
          bold: 'Times-Bold',
          italics: 'Times-Italic',
          bolditalics: 'Times-BoldItalic'
        }

      };


      var docDefinition = {
        content: [
          {
            stack: [
              {text: 'Cancún, Quintana Roo, a ' + nuevaFechafin.format('DD') + ' de ' + nuevaFechafin.format('MMMM') + " del " + nuevaFechafin.format('YYYY') , style: 'subheader' },
            ],
            style: 'header'
          },
          {
            stack: [
              {
                fontSize: 12,
                bold: false,
                text: [
                  datosUser.nameE ,
                  /* the following margin definition doesn't change anything */
                  {text: '\n Presente.- ', style: 'subheader'}
                ],
              }
            ],
            margin: [0, 0, 0, 15],
            alignment: 'justify'
          },
          {
            text: 'Por medio de la presente, en forma voluntaria y por así convenir a mis intereses, renuncio de manera irrevocable al trabajo que venía desempeñando única y exclusivamente para  '+ datosUser.nameE +', desde fecha ' + nuevaFechaini.format('DD') + ' de ' + nuevaFechaini.format('MMMM') +' del ' + nuevaFechaini.format('YYYY') + ' , desempeñando el puesto de '+ datosUser.puesto +', laborando una jornada de trabajo comprendida de Lunes a Sábado de las 09:00 a las 13:00 horas y de las 15:00 a las 19:00 horas interrumpiendo dicha jornada de las 13:00 a las 15:00 horas para descansar e ingerir alimentos fuera de las instalaciones de la empresa, descansando los días domingo de cada semana, jornada de trabajo que siempre estuvo circunscrita a la legal y jamás excedió de la misma, percibiendo por concepto de salario diario la cantidad de $'+ datosUser.sueldo +' pesos diarios, el cual siempre me fue cubierto de manera quincenal.',
            margin: [0, 15],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'Hago constar que a la fecha de la presente renuncia la empresa  '+ datosUser.nameE +', quien fue mi único patrón, no me adeuda cantidad alguna por ningún concepto derivado y/u originado de mi contrato individual y relación de trabajo, ni de la ley federal del trabajo, ya que  '+ datosUser.nameE +', siempre me pagó legal y oportunamente, todos y cada uno de los conceptos y prestaciones a que he tenido derecho como trabajador, tales como: salarios devengados, séptimos días, días festivos, vacaciones, prima vacacional, aguinaldo, utilidades, vales de despensa, comisiones y demás que me hayan llegado a corresponder. De igual forma, hago constar que jamás laboré tiempo extraordinario, por lo que no se me adeuda cantidad alguna por dicho concepto.',
            margin: [0, 15],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: `Así mismo, hago constar que durante el tiempo de la prestación de mis servicios no sufrí accidente de trabajo, ni contraje enfermedad profesional alguna; en virtud de lo anterior, le otorgo a  ${datosUser.sueldo } , el más amplio finiquito que en derecho proceda. No me reservo, por no tener, derecho ni acción alguna derivada de mi relación de trabajo, que ejercitar, ya sea pasada, presente, ni futura, de carácter laboral, civil, mercantil, penal, de seguridad social, fiscal, ni de ninguna otra índole, en ningún lugar, en contra de mi patrón  ${datosUser.nameE }, ni en contra de AGENCIA ENTERTAIMENT PLUS/ USA TRANSFERS, empresas controladoras, matrices, relacionadas, subsidiarias, clientes y afiliadas; ni de sus accionistas, miembros de sus consejos de administración, funcionarios, ejecutivos, directivos, empleados, agentes, ni representantes; hago constar que mi único patrón lo fue ${datosUser.nameE }, y que las relaciones que llegué a tener con cualquier otro establecimiento o unidad económica, o las personas físicas o morales antes mencionadas, siempre lo fueron por cuenta y orden de  ${datosUser.nameE }, y bajo la subordinación exclusiva de esta última.`,
            margin: [0, 15],
            fontSize: 10,
            alignment: 'justify'
          },
          {
            text: 'Atentamente',
            margin: [0, 60],
            fontSize: 11,
            alignment: 'center'
          },
          {
            text: '_____________________________________',
            margin: [0, 1],
            fontSize: 10,
            alignment: 'center'
          },
            {
            text:[{text: datosUser.nombre + ' '+ datosUser.apellido_paterno + ' ' + apellidoMat ,bold:true}  ],
            margin: [0, 10],
            fontSize: 10,
            alignment: 'center'
          }
        ],
        styles: {
          alignment: 'justify',
          header: {
            fontSize: 6,
            bold: false,
            alignment: 'right',
            margin: [0, 0, 0, 40]
          },
          subheader: {
            fontSize: 10
          },
          superMargin: {
            margin: [20, 0, 40, 0],
            fontSize: 15
          }
        }

      }
      pdfMake.createPdf(docDefinition).open();
    },
    generarCambioDePatron:function(empresa, datosUser, fechaContra) {

      console.log('funcion generarcambiosdepatron');

      console.log('la fecha del contrato ' + fechaContra);

      console.log('los datos que llegan empresa : ' + empresa.nombre);
      console.log('los datos que llegan empresa : ' + empresa.representante );

      console.log('los datos usuario : ' + datosUser);
      console.log('los datos nombre : ' + datosUser.nombre);

      var fechaDeCosas = moment(fechaContra,'YYYY-MM-DD');
      var estancia = this;

      var apellidoMater = (datosUser.apellido_materno == '*') ? '' : datosUser.apellido_materno ;
      var nombreEmpleado = datosUser.nombre + " " + datosUser.apellido_paterno + " " + apellidoMater;

      var ultimaFechaEmpresa = moment(datosUser.ultima_empresa_date,'YYYY-MM-DD');
      var ultimaFechaEmpresa2 = ultimaFechaEmpresa.format('DD') + ' de ' + ultimaFechaEmpresa.format('MMMM') + ' del ' + ultimaFechaEmpresa.format('YYYY')

      // playground requires you to assign document definition to a variable called dd

        var fonts = {

          Times: {
            normal: 'Times-Roman',
            bold: 'Times-Bold',
            italics: 'Times-Italic',
            bolditalics: 'Times-BoldItalic'
          }

        };


        var dd = {
        	content: [
        	      {
                    text: 'AVISO DE SUSTITUCION PATRONAL',
                    margin: [10, 10],
                    fontSize: 10,
                    alignment: 'center'
                  },
                  {
                    stack: [
                      {text: 'Cancún, Quintana Roo, a '+ fechaDeCosas.format('DD') +' de '+ fechaDeCosas.format('MMMM') +' del ' + fechaDeCosas.format('YYYY') + ' ', style: 'subheader' },

                    ],
                    margin: [30, 30],
                    style: 'header'
                  },
                  {
                    stack: [
                      {
                        fontSize: 12,
                        bold: false,
                        text: [
                          nombreEmpleado + ' \n ',
                          {text: ' - P R E S E N T E ', style: 'subheader'}
                        ],
                      }
                    ],
                    margin: [0, 0, 0, 15],
                    alignment: 'justify'
                  },
                  {
                    text: 'Por medio de la presente y en los terminos del articulo 41 de la ley Federal del Trabajo le comunicamos que a partir del dia '+ fechaDeCosas.format('DD') +' de '+ fechaDeCosas.format('MMMM') +' del ' + fechaDeCosas.format('YYYY') + ', la empresa '+ empresa.nombre +' se constituyó como patrón sustituto respecto de las obligaciones laborales que tenía para con usted la empresa '+  datosUser.nameE  +', para la cual venía desempeñando sus labores desde fecha '+ ultimaFechaEmpresa2 +', lo anterior en virtud de la sustitución patronal suscitada entre las mencionada empresas, en fecha '+ fechaDeCosas.format('DD') +' de '+ fechaDeCosas.format('MMMM') +' del ' + fechaDeCosas.format('YYYY') + '.' ,
                    margin: [0, 15],
                    fontSize: 12,
                    alignment: 'justify'
                  },
                  {
                    text: 'Así mismo se hace constar para todos los efectos legales a que haya lugar, que la empresa '+ empresa.nombre +', reconoce y respeta las mismas condiciones laborales que usted tenía y venía desempeñando para '+  datosUser.nameE +' las cuales se describen a continuación:',
                    margin: [0, 15],
                    fontSize: 12,
                    alignment: 'justify'
                  },
                  {
            			ul: [
            				' ANTIGUEDAD: ' + ultimaFechaEmpresa2,
            				' PUESTO : ' + datosUser.puesto,
            				' SALARIO DIARIO : $' + datosUser.sueldo+'.00 (' + estancia.NumeroALetras(datosUser.sueldo) + ')',
            				' JORNADA DE LABORES : Lunes a sábado de las 09:00 a las 13:00 horas y de las 15:00 a las 19:00 horas interrumpiendo dicha jornada de las 13:00 a las 15:00 horas para descansar e ingerir alimentos fuera de las instalaciones de la empresa descansando los días domingo de cada semana'
            			]
            	  },
            	   {
                    text: '\n\n\n Comunico a usted lo anterior, para los efectos legales correspondientes \n\n\n',
                    margin: [0, 15],
                    fontSize: 11
                  },
                  {
                  columns: [
                      {
                        text: empresa.nombre  + '\n\n\n\n\n\n ____________________________________ \n ' + datosUser.representanteE ,
                        alignment: 'center',
                        fontSize: 10
                      },
                      {
                        text: 'FIRMA DE ENTERADO Y RECIBO DE CONFORMIDAD \n\n\n\n\n\n ____________________________________ \n  ' + nombreEmpleado,
                        alignment: 'center',
                        fontSize: 10
                      }

                    ]
                  }
                ],
                styles: {
                  header: {
                    fontSize: 6,
                    bold: false,
                    alignment: 'right',
                    margin: [0, 0, 0, 40]
                  },
                  subheader: {
                    fontSize: 10
                  },
                  superMargin: {
                    margin: [20, 0, 40, 0],
                    fontSize: 15
                  }
                }

        }

      pdfMake.createPdf(dd).open();


    },
    generarFiniquitoFinal:function( empresa, datosUser, fechaContra ){ //aqui se genera el finiquito final final

      console.log('-hola aqui se imprime empresa');
      console.log( empresa );

      console.log('-hola aqui se imprime datosUser');
      console.log( datosUser );

      console.log('-hola aqui se imprime fechaContra');
      console.log( fechaContra );

      var fonts = {

        Times: {
          normal: 'Times-Roman',
          bold: 'Times-Bold',
          italics: 'Times-Italic',
          bolditalics: 'Times-BoldItalic'
        }

      };



      var dd = {

      	content: [
              {
                columns: [
          				{
          					text: 'Recibo de Nomina'
          				},
          				{
          					text: 'MR MECHANIC SA DE CV'
          				},
          				{
          					text: 'R.F.C MME-160525-GAB',
          					alignment: 'right'
          				}
          			] ,fontSize:10
              },
              { text: "UUID: "},
              {
                style: 'tableExample',
      			table: {
      				widths: ['*', '*'],
      				body: [
      				    [
      					    {
        			        type: 'none',
                			ul: [
                				{
                  				columns: [
                      				{
                      					text: '40071',
                      					alignment: 'left',
                      					fontSize:10,
                      					width: 40,
                      				},
                      				{
                      					text: 'Eduardo leonel bermon ucan',
                      					fontSize:10,
                      					alignment: 'left',

                      				},
                      				{
                      					text: 'R.F.C MME-160525-GAB',
                      					fontSize:10,
                      					width: 120
                      				},
                      				{
                      					text: 'R.F.C MME-160525-GAB',
                      					fontSize:10,
                      					width: 120
                      				}
                      			]
              				},
              				{
            				    columns: [
                    				{
                    					text: 'Departamento',
                    					fontSize:8,
                    					width: 60,
                    				},
                    				{
                    					text: 'Taller Mecanico',
                    					fontSize:9
                    				},
                    				{
                    					text: 'Dias Trab. 2',
                    					fontSize:9
                    				},
                    				{
                    					text: 'Periodo #24',
                    					fontSize:9
                    				},
                    				{
                    					text: 'QUINCENAL',
                    					fontSize:9
                    				},
                    				{
                    					text: '11/Dic/2018 - 25/Dic/2018',
                    					fontSize:9,
                    					width: 120
                    				}
                    			]
              				}
              			]
        			    , colSpan: 2, alignment: 'center'},
                  { }
                ],
      					[ {text:"PERCEPCIONES", alignment: 'center'} ,  {text:"DEDUCCIONES", alignment: 'center'}],
      					[{
      					    columns: [
                				{
                					text: ' Concepto'
                				},
                				{
                					text: 'Importe',
                					alignment: 'right'
                				}
                			]
      					}, {
      					    columns: [
                				{
                					text: ' Concepto'
                				},
                				{
                					text: 'Importe',
                					alignment: 'right'
                				}
                			]
      					}],
      					[{
              			style: 'tableExample',
              			table: {
              				headerRows: 0,
              				body: [
              					['1', 'Sueldo', '2.00','$','525'],
              					['1', 'Dia festivo/descanso', '2.00','$','525'],
              					['1', 'Vacaciones reportadas', '2.00','$','525'],
              					['1', 'Prima de vacaciones repor', '2.00','$','525'],
              					['1', 'Aguinaldo', '2.00','$','525'],
              				]
              			},
              			layout: 'headerLineOnly',
              			fontSize:10
      					}, {
      					    style: 'tableExample',
              			table: {
              				headerRows: 0,
              				body: [
              					['39', 'Subsidio al empleo (  sp ) ', '2.00','$','525'],
              					['52', 'I.M.S.S', '2.00','$','525'],
              					['99', 'Ajuste al neta', '2.00','$','525']
              				]
              			},
              			layout: 'headerLineOnly',
              			fontSize:10
      					}],
      					[
                  {
                    columns: [
                				{
                					text: 'Suma percepciones $'
                				},
                				{
                					text: '2340'
                				}
                			]    , alignment:'right'
                    },
                		{
                      columns: [
                				{
                					text: 'Suma deducciones $'
                				},
                				{
                					text: '-121.38'
                				}
                			]    , alignment:'right'
                    }
                  ],
      					[ {text:'', border: [false, true, false, false] },
      					{
                  columns: [
            				{
            					text: 'Neto a pagar $'
            				},
            				{
            					text: '2838.40'
            				}
            			]   , alignment:'right', border: [false, true, false, false] } ],
      				]
      			}

              },
              { text:'\n\n\n' },
              {
          	    columns: [
      				{
      					text: 'Recibi de la empresa arriba mencionada la cantidad neta a que este documento se refiere, estando conforme con las percepciones y deducciones que en el aparecen especificados'
      				},
      				{
      					text: '\n\n\n\n\n___________________________________\n Firma del empleado',
      					alignment:'center'
      				}
      			]
      		}

        ],
        defaultStyle: {
           font: 'Times'
         }

      };

      pdfMake.createPdf(dd).open();


    }

  },
  computed:{

  }

}
